import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AppStrings from '../config/appstring';

const SalesTable = ({user}) => {
  const [data, setData] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  // Fetch data on mount
  useEffect(() => {

    console.log("Logged in as:", user?.name);

    const fetchData = async () => {
      try {
        const response = await axios.get(AppStrings.PendingFeeDetails);
        const result =  response.data.data;
//console.log('11111111111111111111111111111111111',result);
        if (Array.isArray(result)) {
         // console.log('2222222222222222',result);
          
          setData(result);
         // console.log('44444444444',data);
          setError('');
        } else {
          setError('Unexpected response format');
        }
      } catch (err) {
        setError('Failed to fetch data');
        console.error("Fetch error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [user]);

  // const handleChange = (rowIdx, colIdx, value) => {
  //   const newData = [...data];
  //   console.log('33333333333333',newData);
  //   newData[rowIdx][colIdx] = value;
  //   setData(newData);
  // };

  // const autoFillColumn = (colIdx) => {
  //   const newData = [...data];
  //   for (let row = 1; row < newData.length; row++) {
  //     newData[row][colIdx] = newData[0][colIdx];
  //   }
  //   setData(newData);
  // };

  const saveData = async () => {
    try {
      await axios.post('http://localhost:4000/api/table-data', data);
      alert('Data saved!');
    } catch (err) {
      alert('Save failed!');
      console.error("Save error:", err);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;

  return (
    <div>
      <h2>Sales Table</h2>
      <table border="1" cellPadding="5">
         <thead>
           <tr>
    <th colSpan={data.length > 0 ? Object.keys(data[0]).length : 1}>
      Sales Information
    </th>
  </tr>
        <tr>
          {data.length > 0 &&
            Object.keys(data[0]).map((key, i) => (
              <th key={i}>{key}</th>
            ))}
        </tr>
      </thead>
        <tbody>
        {data.map((row, rowIdx) => (
  <tr key={rowIdx}>
    {Object.values(row).map((cell, colIdx) => (
      <td key={colIdx}>
      
          {cell}
     
      </td>
    ))}
  </tr>
))}
        </tbody>
      </table>
      <button onClick={saveData}>Save</button>
    </div>
  );
};

export default SalesTable;
